import React, { Component } from "react";

class Sanckbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  componentDidUpdate() {
    if (this.props.mounted !== this.state.show) {
      this.setState({ show: this.props.mounted });
    }
  }

  render() {
    return (
      <div className={`snack-bar ${this.state.show ? "mounted" : "unmounted"}`}>
        <div className="message-body">
          <i
            className="material-icons snackbar-icon"
            style={{ color: this.props.msg.color }}
          >
            {this.props.msg.icon}
          </i>
          <div className={"message"}>{this.props.msg.text}</div>
        </div>
        <i
          className="material-icons close-icon"
          onClick={e => this.props.close(false)}
        >
          close
        </i>
      </div>
    );
  }
}

export default Sanckbar;
